import HeadNav from "../../components/HeadNav";
import {cutPhone, cutPhone1, showTotalData, fmDate, done} from "../../tools";
import {Toast} from 'vant';
import ListEmpty from "../../components/ListEmpty";
import {
  powerWithdrawTotalDistributionIncome,
  setUnit1,
  powerUserTotalDayIncomeCanWithdraw,
  powerUserTotalDayIncomeCanWithdrawUnclaimed,
  getCFCCurrentPrice,
  powerUserTotalDistributionIncomeCanWithdraw,
  getStartBlock,
  getEventData,
  getEarningInfoArr,
  getDayNumber,
  powerUserTotalDayIncomeCanWithdrawReleased, powerCfcON
} from "../../tools/chain";
import {
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub,
  substringStr,
  substringStr1
} from "../../tools/indexFun";
import {contractAddress, powerReleaseCreateBlock} from "../../config";
let bCure = false;

export default {
  name: "inviteFriends",
  components: {
    HeadNav,
    ListEmpty
  },
  data() {
    return {
      show: false,
      tabIndex: '',
      buttonIndex: 0,
      money: 0,
      exchange: 0,
      userTotalDistributionIncome: 0,
      userTotalDistributionIncomeCanWithdraw: 0,
      CFCCurrentPrice: 0,
      iPowerUserTotalDistributionIncomeCanWithdraw: 0,
      iPowerUserTotalDayIncomeCanWithdraw: 0,
      ipowerUserTotalDayIncomeCanWithdrawUnclaimed: 0,
      ipowerCfcON: 0,
      ipowerUserTotalDayIncomeCanWithdrawReleased: 0,
      commissionRelationshipChildren: [],
      depositLog: [
      ],
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    BigNumberAdd(num1,num2,col){
      return BigNumberAdd(num1,num2,col);
    },
    substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
    done(param1, param2) {
      return done(param1, param2)
    },
    changeList(){
      this.buttonIndex=1
      this.getList()
    },
    changeList2(){
      this.buttonIndex=0
      this.getList()
    },
    showTotalData(data) {
      return showTotalData(data)
    },
    goToWI() {
      this.tabIndex = 0
      setTimeout(() => {
        this.$router.push(`/withdrawCFC/${this.tabIndex}`)
      }, 200);
      this.show = false;
    },
    goToWI2() {
      this.tabIndex = 1
      setTimeout(() => {
        this.$router.push(`/withdrawCFC/${this.tabIndex}`)
      }, 200);
    },
    goToCFC(item){
      this.tabIndex = item
      this.$router.push(`/ReferralIncome/${this.tabIndex}`)
    },
    refresh() {
      this.getCFCCurrentPrice();
      this.powerUserTotalDistributionIncomeCanWithdraw();
      this.powerUserTotalDayIncomeCanWithdraw();
      this.powerUserTotalDayIncomeCanWithdrawUnclaimed();
      this.powerCfcON();
      this.powerUserTotalDayIncomeCanWithdrawReleased();
      this.getList()
    },
    cutPhone(phone) {
      return cutPhone(phone);
    },
    cutPhone1(phone) {
      return cutPhone1(phone);
    },
    setUnit1(phone) {
      return setUnit1(phone);
    },
    fmDate(phone) {
      return fmDate(phone);
    },
    async onsubmit() {
      if (this.ipowerCfcON===0) {
        Toast({
          type:"fail",
          message:this.langUtil(155)
        });
        return
      }
      if (this.ipowerUserTotalDayIncomeCanWithdrawUnclaimed===0){
        Toast({
          type:"fail",
          message:this.langUtil(80)
        });
      }else {
      try {
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await powerWithdrawTotalDistributionIncome();
        Toast.clear();
        this.refresh();
        Toast.success({
          message: this.langUtil(72),
          onClose: () => {
          }
        })
      }catch (e){
        bCure = false;
        Toast.clear();
        // Toast({
        //   type: "fail",
        //   message: "sorry, the transaction is fail:" + e.message || e.toString(),
        // });
      }}

    },
    async getCFCCurrentPrice() {
      this.CFCCurrentPrice = await getCFCCurrentPrice(contractAddress.CFCToken, this.$store.state.accounts[0]);
    },
    async powerUserTotalDistributionIncomeCanWithdraw() {
      this.iPowerUserTotalDistributionIncomeCanWithdraw = await powerUserTotalDistributionIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
    async powerUserTotalDayIncomeCanWithdraw() {
      this.iPowerUserTotalDayIncomeCanWithdraw = await powerUserTotalDayIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
    async powerUserTotalDayIncomeCanWithdrawUnclaimed() {
      this.ipowerUserTotalDayIncomeCanWithdrawUnclaimed = await powerUserTotalDayIncomeCanWithdrawUnclaimed(this.$store.state.accounts[0]);
    },
    async powerCfcON() {
      this.ipowerCfcON = await powerCfcON();
      console.log('ipowerCfcON',this.ipowerCfcON)
    },
    async powerUserTotalDayIncomeCanWithdrawReleased() {
        this.ipowerUserTotalDayIncomeCanWithdrawReleased = await powerUserTotalDayIncomeCanWithdrawReleased(this.$store.state.accounts[0]);
    },
    // async getEarningInfoArr() {
    //   this.depositLog = await getEarningInfoArr(1, 200, this.$store.state.accounts[0]);
    //   console.log('___10', this.depositLog)
    // },
    async getList(toBlock){
      if (!toBlock){
        toBlock = await getStartBlock();
      }
      let list = [];
      this.depositLog = [];
      const request = async (toBlock) => {
        console.log(toBlock, "等待者区块数");
        // let fromBlock = toBlock - 1023;
        let fromBlock = toBlock - 3000;
        const eventConf = {
          fromBlock,
          toBlock,
          filter: {
            user: this.$store.state.accounts[0]
          },
        };
        var res
        if (this.buttonIndex==1){
          // res = await getEventData("LogDistributionIncome", eventConf);
          // console.log('___70', res)
          // for (let k = res.length - 1; k >=0; k--) {
          //   list.push(res[k].returnValues)
          // }
          // if (fromBlock > powerReleaseCreateBlock) {
          //   await request(fromBlock)
          // }
        }else{
          res = await getEarningInfoArr(1,200, this.$store.state.accounts[0]);
          for(let k = res.length - 1; k >=0; k--){
            let item = {...res[k]};
            item.startTimeTitle = await getDayNumber(item.startTime,Date.now());
            list.push(item)
          }
          if (this.buttonIndex==1) {
            list=[]
          }
        }
      }
      await request(toBlock);
      this.depositLog = list;
      console.log('___100', this.depositLog)
    },
  },
  mounted() {
    this.refresh();
  }
}
